import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { useFormikContext } from "formik";
import React from "react";
import useQuote from "../../hooks/useQuote";
import { FixAndFlipForm } from "../../lib/models/short-term/short-term-form.model";
import {
  RentalForm,
  RentalPremierForm,
} from "../../lib/models/rental/rental-form.model";

export interface SaveAsQuoteDialogProps {
  isOpen: boolean;
  onOpen?: () => void;
  onClose: () => void;
  onSaveClick: (
    values: FixAndFlipForm | RentalForm | RentalPremierForm
  ) => void;
}

function SaveAsQuoteDialog(props: SaveAsQuoteDialogProps) {
  const { isOpen, onClose, onSaveClick } = props;
  const { values } = useFormikContext<
    FixAndFlipForm | RentalForm | RentalPremierForm
  >();
  const { state } = useQuote();

  const initialName = `Copy of ${values.quoteName}`;
  const [newQuoteName, setNewQuoteName] = React.useState<string>(initialName);

  const handleSaveClick = () => {
    const copyOfValues = Object.assign({}, values);
    copyOfValues.quoteName = newQuoteName;
    copyOfValues.username = state.username;

    onSaveClick && onSaveClick(copyOfValues);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Save Quote As</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <FormControl>
            <FormLabel>Quote Name</FormLabel>
            <Input
              onChange={(e: any) => {
                setNewQuoteName(e.target.value);
              }}
              value={newQuoteName}
              placeholder={initialName}
            />
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <Button
            onClick={handleSaveClick}
            isDisabled={newQuoteName.length < 1}
            variant="brand"
            mr={3}
          >
            Save
          </Button>
          <Button onClick={onClose}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default SaveAsQuoteDialog;
